goog.provide("shadow.js.shim.module$date_fns$locale$id$default");
shadow.js.shim.module$date_fns$locale$id$default = esm_import$date_fns$locale$id.default;
